import { render, staticRenderFns } from "./CapitalRecord.vue?vue&type=template&id=619c8cdd&scoped=true"
import script from "./CapitalRecord.vue?vue&type=script&lang=js"
export * from "./CapitalRecord.vue?vue&type=script&lang=js"
import style0 from "./CapitalRecord.vue?vue&type=style&index=0&id=619c8cdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c8cdd",
  null
  
)

export default component.exports